/* "Leggi di più / Leggi di meno" toggle for collection & brand descriptions.
   Only shows the toggle when the text actually overflows the collapsed height,
   so short descriptions are never cropped unnecessarily. Fails safe: if this
   script doesn't run, the full description stays visible (never hidden). */
(function () {
  function getMaxLines() {
    return window.matchMedia('(min-width: 768px)').matches ? 4 : 3;
  }

  function expand(textEl) {
    textEl.style.maxHeight = '';
    textEl.style.overflow = '';
  }

  function collapse(textEl, height) {
    textEl.style.maxHeight = height + 'px';
    textEl.style.overflow = 'hidden';
  }

  function initReadMore(wrapper) {
    var textEl = wrapper.querySelector('[data-read-more-text]');
    var toggleBtn = wrapper.querySelector('[data-read-more-toggle]');
    if (!textEl || !toggleBtn) return;

    var labelMore = toggleBtn.querySelector('[data-read-more-label-more]');
    var labelLess = toggleBtn.querySelector('[data-read-more-label-less]');
    var collapsedHeight = null;
    var isExpanded = false;

    function measure() {
      expand(textEl);

      var lineHeight = parseFloat(window.getComputedStyle(textEl).lineHeight);
      if (isNaN(lineHeight)) lineHeight = 24;
      collapsedHeight = Math.round(lineHeight * getMaxLines());

      var naturalHeight = textEl.scrollHeight;

      if (naturalHeight > collapsedHeight + 4) {
        toggleBtn.hidden = false;
        if (!isExpanded) collapse(textEl, collapsedHeight);
      } else {
        toggleBtn.hidden = true;
        expand(textEl);
      }
    }

    toggleBtn.addEventListener('click', function () {
      isExpanded = !isExpanded;
      if (isExpanded) {
        expand(textEl);
        if (labelMore) labelMore.hidden = true;
        if (labelLess) labelLess.hidden = false;
        toggleBtn.setAttribute('aria-expanded', 'true');
      } else {
        collapse(textEl, collapsedHeight);
        if (labelMore) labelMore.hidden = false;
        if (labelLess) labelLess.hidden = true;
        toggleBtn.setAttribute('aria-expanded', 'false');
      }
    });

    measure();

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (!isExpanded) measure();
      }, 200);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var wrappers = document.querySelectorAll('[data-read-more]');
    for (var i = 0; i < wrappers.length; i++) {
      initReadMore(wrappers[i]);
    }
  });
})();
